import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const BaseSVG = styled.svg`
  path {
    transition-property: fill;
    transition-duration: 0.25s;
  }
`;

const Logo = ({ height, color }) => (
  <BaseSVG
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 119 35"
    height={height}
  >
    <title>Vitae</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="M31.482 9.895a2.414 2.414 0 0 1 2.405-2.423 2.414 2.414 0 0 1 2.404 2.423v22.619a2.414 2.414 0 0 1-2.404 2.423 2.414 2.414 0 0 1-2.405-2.423V9.895zm14.265 9.896a2.414 2.414 0 0 1 2.405-2.424 2.414 2.414 0 0 1 2.404 2.424v10.3h2.605a2.414 2.414 0 0 1 2.404 2.423 2.414 2.414 0 0 1-2.404 2.423h-2.604c-2.75.001-4.808-2.074-4.809-4.846v-10.3zm34.125-4.87a8.756 8.756 0 0 0-6.234-2.602 8.754 8.754 0 0 0-6.234 2.602 8.892 8.892 0 0 0-2.582 6.283c0 2.455.987 4.676 2.582 6.284a8.754 8.754 0 0 0 6.234 2.602 8.756 8.756 0 0 0 6.234-2.602 8.893 8.893 0 0 0 2.582-6.284 8.894 8.894 0 0 0-2.582-6.283zm2.582-5.026a2.414 2.414 0 0 1 2.404-2.423 2.414 2.414 0 0 1 2.405 2.423v22.619a2.414 2.414 0 0 1-2.405 2.423 2.414 2.414 0 0 1-2.404-2.423v-.84a13.509 13.509 0 0 1-8.816 3.263 13.529 13.529 0 0 1-9.633-4.022 13.742 13.742 0 0 1-3.991-9.71 13.74 13.74 0 0 1 3.99-9.71 13.526 13.526 0 0 1 9.634-4.023c3.362 0 6.44 1.228 8.816 3.263v-.84zm34.142 13.733H96.89a8.902 8.902 0 0 0 2.25 3.86 8.764 8.764 0 0 0 9.962 1.77 8.817 8.817 0 0 0 3.027-2.337 2.388 2.388 0 0 1 3.38-.303 2.433 2.433 0 0 1 .301 3.408 13.658 13.658 0 0 1-4.68 3.625 13.539 13.539 0 0 1-15.39-2.736 13.744 13.744 0 0 1-3.99-9.71c0-3.792 1.525-7.225 3.99-9.71a13.527 13.527 0 0 1 9.634-4.023 13.53 13.53 0 0 1 9.634 4.023 13.744 13.744 0 0 1 3.991 9.71 2.414 2.414 0 0 1-2.404 2.423zM96.89 18.78h16.968a8.893 8.893 0 0 0-2.25-3.86 8.755 8.755 0 0 0-6.234-2.602 8.754 8.754 0 0 0-6.234 2.602 8.9 8.9 0 0 0-2.25 3.86zM31.482 2.423A2.414 2.414 0 0 1 33.887 0a2.414 2.414 0 0 1 2.404 2.423 2.414 2.414 0 0 1-2.404 2.424 2.414 2.414 0 0 1-2.405-2.424zm-4.488 8.552a2.43 2.43 0 0 0-1.08-3.247 2.394 2.394 0 0 0-3.221 1.088l-9.07 18.335-9.07-18.335a2.394 2.394 0 0 0-3.22-1.088 2.43 2.43 0 0 0-1.08 3.247l11.22 22.681a2.393 2.393 0 0 0 4.302 0l11.22-22.681z"
        fill={color || '#003DA5'}
      />
      <path
        d="M42.433 9.933a2.433 2.433 0 0 1 0-4.865h2.635V2.433a2.432 2.432 0 1 1 4.864 0v2.635h2.635a2.433 2.433 0 0 1 0 4.865h-2.635v2.635a2.432 2.432 0 0 1-4.864 0V9.933h-2.635z"
        fill={color || '#E85E85'}
      />
    </g>
  </BaseSVG>
);

Logo.propTypes = {
  height: PropTypes.number,
  color: PropTypes.string,
};

Logo.defaultProps = {
  height: 35,
  color: null,
};

export default Logo;
